export const companyProfileSeed = {
  companyName: 'Acme Oman LLC',
  domain: 'acme.example',
  timezone: 'Asia/Muscat',
  primaryLanguage: 'en',
  secondaryLanguage: 'ar',
  supportContactEmail: 'support@acme.example',
  tenantCode: 'T-204',
  plan: 'Business Plus',
  createdAt: '2024-01-15',
};

export const timezonesSeed = [
  { value: 'Asia/Muscat', label: 'Asia/Muscat (GST)' },
  { value: 'Asia/Dubai', label: 'Asia/Dubai (GST)' },
  { value: 'UTC', label: 'UTC' },
  { value: 'Europe/London', label: 'Europe/London' },
];

export const languagesSeed = [
  { value: 'en', label: 'English' },
  { value: 'ar', label: 'Arabic' },
  { value: 'fr', label: 'French' },
];

export const brandingSeed = {
  primaryColor: '#644998',
  secondaryColor: '#107C10',
  logoUrl: 'https://cdn.example/branding/acme-logo.png',
  faviconUrl: 'https://cdn.example/branding/favicon.ico',
  botDisplayName: 'Acme MeetingHub Bot',
  portalTitle: 'Acme MeetingHub',
};

export const policiesRetentionSeed = {
  platformMinimums: {
    transcriptDays: 90,
    momDays: 90,
    recordingDays: 30,
    auditDays: 365,
  },
  transcriptDays: 365,
  momDays: 400,
  recordingDays: 180,
  auditDays: 730,
  piiMasking: true,
  guestRetentionDays: 60,
  allowMomDownload: true,
  legalFooter: 'Confidential — Acme Oman LLC',
  disclaimer: 'AI-generated content may contain errors.',
  requireLegalAckOnApproval: false,
  allowUserDataExport: true,
  exportFormats: ['CSV', 'XLSX', 'PDF'],
};
